import { useCallback } from 'react'
import { useShareModal } from '@publisher/modules/share/hooks'
import { useChatModal } from '@publisher/modules/chat/hooks'
import { useChatModalContext } from '@publisher/modules/chat/contexts/chat-modal'
import { useAnalytics } from '@publisher/modules/analytics/hooks'
import { TRequestEventName } from '@publisher/modules/analytics/channels'
import type { TPublisherRequest } from '@modules/types'

interface UseModalActionsProps {
  id?: number
  selectedRequest?: TPublisherRequest
}

export const useModalActions = ({ id, selectedRequest }: UseModalActionsProps) => {
  const { openShareModal } = useShareModal()
  const { openChatModal } = useChatModal()
  const { open: chatOpen, handleClose: handleCloseChat } = useChatModalContext()
  const { channels } = useAnalytics()

  const handleShare = useCallback(() => {
    if (id) {
      channels.request.send({
        event: TRequestEventName.Share,
        requestId: id,
      })
    }

    openShareModal(
      selectedRequest?.songs || [],
      id,
      selectedRequest?.clientRequest?.publicationTitle,
      selectedRequest?.clientRequest?.distributionTerritory,
      selectedRequest?.clientRequest?.plannedPublicationDate,
    )
  }, [id, channels, openShareModal, selectedRequest])

  const handleChat = useCallback(() => {
    if (chatOpen) {
      handleCloseChat()
    } else if (id) {
      openChatModal(id.toString())
    }
  }, [chatOpen, handleCloseChat, id, openChatModal])

  return {
    chatOpen,
    handleShare,
    handleChat,
  }
}
